define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		process: function() {
			// summary: reset form data to form defaults for current view
			this.widget.resetFormToDefaults();
			this.inherited(arguments);
		}
	});
});